import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import './styles/_global.css';
import './styles/home.css';
import Home from "./components/Home";
import ParticlesComponent from './components/DynamicBackground';
import CookieConsentModule from './components/CookieConsent';
import NotFoundPage from './components/NotFoundPage';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';

// Lazy-loaded so each page's own dependencies (react-markdown/remark-gfm
// for the blog, etc.) aren't pulled into the initial bundle for visitors
// who land on the homepage and never navigate further.
const About = lazy(() => import("./components/About"));
const Partners = lazy(() => import("./components/Partners"));
const Rules = lazy(() => import("./components/Rules"));
const Faq = lazy(() => import("./components/Faq"));
const Legal = lazy(() => import("./components/Legal"));
const BlogPage = lazy(() => import("./components/blog/BlogPage"));
const BlogPostPage = lazy(() => import("./components/blog/BlogPostPage"));
const EventsPage = lazy(() => import("./components/events/EventsPage"));
const EventDetailPage = lazy(() => import("./components/events/EventDetailPage"));
const EventsGate = lazy(() => import("./components/events/EventsGate"));

// The Drive Days section was renamed to Events (to cover all club events,
// not just drive days) — these keep any old /drive-days links working.
function RedirectToEventSlug() {
  const { slug } = useParams();
  return <Navigate to={`/events/${encodeURIComponent(slug)}`} replace />;
}

function App() {
  return (
    <div className='App'>
      <ErrorBoundary>
        <CookieConsentModule />
        <Header />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="partners" element={<Partners />} />
            <Route path="rules" element={<Rules />} />
            <Route path="faq" element={<Faq />} />
            <Route path="legal" element={<Legal />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/:slug" element={<BlogPostPage />} />
            <Route path="events" element={<EventsGate><EventsPage /></EventsGate>} />
            <Route path="events/:slug" element={<EventsGate><EventDetailPage /></EventsGate>} />
            <Route path="drive-days" element={<Navigate to="/events" replace />} />
            <Route path="drive-days/:slug" element={<RedirectToEventSlug />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
        <ParticlesComponent id="particles" />
      </ErrorBoundary>
    </div>
  );
}

export default App;
